export const blockIconsAndroidSignalCellular4BarNew = (
	<span className='material-symbols-outlined'>signal_cellular_4_bar</span>
);
